<template>
    <div style="width: 100%;">

        <modal
                v-model="attributeValue"
                v-show="isModalVisible"
                @close="closeModal"
                @validate="validateModal"/>

        <div class="form-field form-autocomplete" :rel="name">
            <div class="form-label">
                <label>{{ label }}</label>
            </div>
            <div class="form-input">
                <div class="form-input-wrapper" style="padding-right: 40px;">

                    <component-multiselect v-model="internalValue"
                                           :show-labels="false"
                                           label="name"
                                           track-by="id"
                                           value="String"
                                           placeholder="Selection"
                                           :options="options"
                                           :multiple="isMultiple"
                                           :internal-search="true"
                                           :clear-on-select="true"
                                           :show-no-results="true"
                                           :hide-selected="true"></component-multiselect>
                </div>
                <div style="position: absolute;width: 40px;right: 0; top: 50%; transform: translateY(-50%);"><button @click="addAttributeValue()">Add</button></div>
            </div>
        </div>
    </div>
</template>

<script>

    import AttributeService from './AttributeService.js';
    import Modal from './Modal.vue'

    export default {
        components: {
            Modal,
        },
        name: 'FormField',
        props: ['value','label','name','placeholder','multiple', 'default','options','callback','id'],
        data: function () {
            return {
                internalValue: '',
                isModalVisible: false,
                attributeValue: {edit:false, data:null},
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.isMultiple = this.multiple == 'true' ? true : false;
            this.onChange = this.callback ? true : false;

            this.locales = this.$store.state.scope.locales
            this.locale = this.$store.state.scope.locales[0].id
        },
        methods: {
            addAttributeValue: function(){
                var data = {
                    attribute_id: this.id,
                    id: null,
                    ref: "",
                    is_default: 0,
                    translations:{}
                };

                for(let locale of this.locales){
                    data.translations[locale.id] = {
                        name:'',
                        description:''
                    }
                }

                this.attributeValue.edit =  false
                this.attributeValue.data =  data
                this.isModalVisible = true
            },
            closeModal() {
                this.isModalVisible = false;
            },
            validateModal() {

                //console.log("Data", this.attributeValue.data);

                AttributeService.addValue(this.attributeValue.data).then(response => {
                    //console.log("Response", response.data)
                    this.internalValue.push(response.data);
                    this.options.push(response.data);
                    this.closeModal()
                })

            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'default'(newVal, oldVal) {
                if( newVal && this.options){
                    for (let item of this.options) {
                        if( item.id && item.id.toString().toLowerCase() == newVal.toString().toLowerCase() ){
                            this.internalValue = item;
                        }
                    }
                }
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
                if( this.onChange ){
                    this.callback(this.internalValue)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/attribute/Select.vue